import { Injectable } from '@angular/core';
import {
    ISearchConfig,
    ISortConfig,
    IFilterConfig,
    IPaginationConfig,
    ITableState,
    SortDirection,
    SortType,
    FilterOperator,
    ISearchResult,
    IDateRange,
    INumberRange
} from './search-sort.models';
import { BehaviorSubject, Observable } from 'rxjs';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class SearchSortService {
    search<T>(data: T[], config: ISearchConfig): T[] {
        if (!config.searchTerm || config.searchTerm.trim() === '') {
            return data;
        }
        const searchTerm = config.caseSensitive ? config.searchTerm.trim() : config.searchTerm.trim().toLowerCase();
        return data.filter(item => {
            if (config.customPredicate) {
                return config.customPredicate(item, searchTerm);
            }
            return config.searchFields.some(field => {
                const value = this.getNestedValue(item, field);
                if (value === null || value === undefined) {
                    return false;
                }
                const stringValue = config.caseSensitive ? String(value) : String(value).toLowerCase();
                if (config.exactMatch) {
                    return stringValue === searchTerm;
                } else {
                    return stringValue.includes(searchTerm);
                }
            });
        });
    }
    private getNestedValue(obj: any, path: string): any {
        return path.split('.').reduce((current, prop) => current?.[prop], obj);
    }
}
